import { CrmAddonGate } from '@/pages/crm/addon/AddonGate';
import { DealDetailPage } from '@/pages/crm/deals/DealDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { createFileRoute } from '@tanstack/react-router';

// Addon-off resolves to the B1 upsell teaser without fetching any Deal data: the gate
// only renders the detail container when the tenant is entitled (addon OR chain).
function DealDetailRoute() {
	return (
		<CrmAddonGate>
			<DealDetailPage />
		</CrmAddonGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/crm/deals/$dealId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['deals.read.own', 'deals.read.all'], redirectTo: '/dashboard' }),
	component: DealDetailRoute,
});
